import React, {memo} from 'react';
import {Platform, useWindowDimensions} from 'react-native';
import {ProjectParams} from '../../../types/nav';
import {MobileBanner} from './mobilebanner';
import {DesktopBanner} from './desktopbannner';
function EditorBanner({
  projectId,
  routeParams,
}: {
  projectId: string;
  routeParams: ProjectParams;
}) {
  const {width} = useWindowDimensions();
  const isMobile = width < 700 || Platform.OS !== 'web';
  console.info('editorbanner reload');
  if (isMobile) {
    return (
      <MobileBanner projectId={projectId} routeParams={routeParams} />
    );
  }
  return (
    <DesktopBanner projectId={projectId} routeParams={routeParams} />
  );
}

export default memo(EditorBanner);
